import React, { useState } from 'react';

import { Button } from '@components/Button';
import { UnsharableDialog } from '@components/utilities/Bookings/UnsharableDialog';
import Grid from '@material-ui/core/Grid';
import { ZendeskIframeManager } from '@store/ZendeskIframeManager';
import { makeMuiStyles, useCommonStyles } from '@styles';
import { createStrings } from '@utils/local';
import clsx from 'clsx';

const useStyles = makeMuiStyles((theme, common) => ({
  dtText: {
    ...common.middleText,
    color: theme.palette.grey[700],
  },
  ddText: {
    ...common.middleText,
    marginLeft: '1rem',
  },
}));

const strings = createStrings({
  ja: {
    d2dNo: 'D2D番号',
    createdAt: '作成時間',
    status: 'ステータス',
    contactD2d: 'D2Dに連絡する',
    shareInquiry: '予約を共有する',
  },
});

export const BookingInquiryInformation: React.FC<BookingInquiryInformationProps> = (props) => {
  const classes = {
    ...useCommonStyles(),
    ...useStyles(),
  };
  const { d2dNo, createdAt, status, onShare, unsharable } = props;

  const [isDialogOpen, setIsDialogOpen] = useState(false);

  const onContact = () => {
    ZendeskIframeManager.shared.openTicketForD2dNo(d2dNo);
  };

  return (
    <div className={clsx(classes.flexInline)}>
      <UnsharableDialog open={isDialogOpen} onClose={() => setIsDialogOpen(false)} />
      <Grid container spacing={4} style={{ marginTop: 8 }}>
        <Grid container spacing={2} item xs={12}>
          <Grid item xs={12} sm={3}>
            <span className={classes.dtText}>{strings.d2dNo}</span>
          </Grid>
          <Grid item xs={12} sm={9}>
            <span className={classes.ddText}>{d2dNo}</span>
          </Grid>
        </Grid>
        <Grid container spacing={2} item xs={12}>
          <Grid item xs={12} sm={3}>
            <span className={classes.dtText}>{strings.createdAt}</span>
          </Grid>
          <Grid item xs={12} sm={9}>
            <span className={classes.ddText}>{createdAt}</span>
          </Grid>
        </Grid>
        <Grid container spacing={2} item xs={12}>
          <Grid item xs={12} sm={3}>
            <span className={classes.dtText}>{strings.status}</span>
          </Grid>
          <Grid item xs={12} sm={9}>
            <span className={classes.ddText}>{status}</span>
          </Grid>
        </Grid>
      </Grid>
      <div
        className={clsx(classes.flexColumn, classes.verticalSpace1)}
        style={{ width: 136, flexShrink: 0 }}
      >
        <Button color="primary" size="small" text={strings.contactD2d} onClick={onContact} />

        <Button
          color={unsharable ? 'grey' : 'accent'}
          size="small"
          text={strings.shareInquiry}
          onClick={unsharable ? () => setIsDialogOpen(true) : onShare}
        />
      </div>
    </div>
  );
};

export interface BookingInquiryInformationProps {
  d2dNo: string;
  createdAt: string;
  status: string;
  onShare?: () => void;
  unsharable?: boolean;
}
